import { emptyCrmInstances } from '@/components/Company/importer/crmInstances';

const initialMappingState = {
  rows: [],
  catalog: [],
  counts: { all: 0, mapped: 0, review: 0, ignored: 0 },
  recordCount: null,
  validation: { valid: false, reasons: [] },
};

const initialState = {
  // Dashboard (TBR-5907)
  jobs: [],
  counts: { done: 0, in_progress: 0, error: 0 },
  statusFilter: 'all',
  page: 1,
  pagination: { total_items: 0, page_size: 10 },
  status: 'idle',
  retryingIds: [],
  contactsExportIds: [],
  detailJobId: null,
  error: null,
  // Wizard (TBR-5917)
  activeStep: 1,
  entity: null, // 'properties' | 'developments' | 'contacts' | 'owners'
  mode: null, // 'portal_crm' | 'crm' | 'contacts' | 'owners'
  origin: null,
  files: [],
  // CRM bundle wizard (TBR-6074)
  crmInstances: emptyCrmInstances(),
  crmRequiredFiles: [],
  crmRequiredStatus: 'idle',
  // Files the upload rejected: never stored by the backend, but the checklist
  // has to mark the required workbook they were meant to satisfy.
  uploadRejections: [],
  crmConfigStatus: 'idle',
  // Status of the async bundle parse triggered by crmConfigStatus
  // 'succeeded' (idle/running/finished/error), driven by useCrmConfigPolling.
  crmConfigParseStatus: 'idle',
  crmConfigParseError: null,
  apiKey: '',
  apiCredentialsStatus: 'idle',
  recordCounts: null,
  // True when the CRM bundle's signed image URL has expired (Vista/Loft).
  imagesUrlExpired: false,
  imagesExpiredCounts: null,
  importWithoutImages: true,
  // Wizard submission (TBR-5985)
  jobId: null,
  uploadResults: [], // server upload response entries
  recordCount: null,
  uploadStatus: 'idle', // idle | loading | succeeded | failed
  startStatus: 'idle', // idle | loading | succeeded | failed
  submitError: null,
  submitErrorReason: null,
  mapping: initialMappingState,
  mappingStatus: 'idle',
  mappingSaveStatus: 'idle',
  mappingSavingSourceColumnIndex: null,
  mappingRowsBackup: null,
  // Value mappings (TBR-5921)
  valueMappings: null,
  valueMappingsStatus: 'idle',
  valueMappingsSaveStatus: 'idle',
  valueMappingsError: null,
  readyForStart: false,
  agentMappingsDraft: {},
  leadStatusMappingsDraft: {},
  agentDefaultDraft: null,
  leadStatusDefaultDraft: null,
  // Tracks the most recently dispatched save request per block, so that if a
  // change fires a new save while an older one is still in flight, the older
  // one's response (built from a stale draft) is ignored instead of
  // overwriting the newer local edits it doesn't know about.
  agentMappingsSaveRequestId: null,
  leadStatusMappingsSaveRequestId: null,
  importSettingsDraft: {},
};

export { initialMappingState };
export default initialState;
